import React, { useState } from 'react';
import { Button, Grid, MenuItem, Skeleton } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import callIcon from 'assets/images/callLogo.svg';
import mailIcon from 'assets/images/mailLogo.svg';
import locationIcon from 'assets/images/locationLogo.svg';
import calender from 'assets/images/calender.svg';
import CommonDialog from 'components/commonDialog/CommonDialog';
import SuccessDialog from 'components/successDialog/SuccessDialog';
import { dateFormate } from 'utils/utils';

function SubHeaderDetails(props) {
  const [edit, setEdit] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const details = props.details

  const onEditButton = () => {
    setEdit(true);
  };

  const handleClose = () => {
    setEdit(false);
    setSuccessDialog(false);
  };

  const onDialog = (data,code) => {
    props.onSubmittBtn(data,code)
    setEdit(false);
    setSuccessDialog(false); //should be open for success api
  };

  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      className="vendorAbout"
      md={props?.type === 'Driver' ? 12 :3.3}
    >
      <Grid
        item
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <h4 className="fontMedium font16">About</h4>
        <Grid item>
          {props?.editIconFalse ? null : <Button
            variant="contained"
            className="vendorEditBtn"
            onClick={() => {
              onEditButton();
            }}
          >
            <span>
              <EditOutlinedIcon />
            </span>
          </Button>}
        </Grid>
      </Grid>
      <Grid item direction="row" just>
        {props?.loader ?  <Skeleton animation="wave"  width={200} height={50}/> : 
        <MenuItem className="iconAlign subHeaderCard">
          <img src={mailIcon} alt="mail icon"  />

          <p className="font14  marginInline textWrap">{details?.email ? details?.email : 'Not Available'}</p>
        </MenuItem>}
         
        {props?.loader ?  <Skeleton animation="wave" width={200} height={50}/> : 
        <MenuItem className="iconAlign subHeaderCard">
          <img src={callIcon} alt="callIcon"  />

          <p className="  font14 marginInline textWrap">{details?.mobile ? details?.mobile : 'Not Available'}</p>
        </MenuItem>}
        {props?.loader ?  <Skeleton animation="wave" width={200} height={50}/> : 
        <MenuItem className="iconAlign subHeaderCard">
          <img src={locationIcon} alt="location"  />

          <p className=" font14  marginInline textWrap">
            {details?.location ? details?.location : details?.city ? details?.city : 'Not Available'}
          </p>
        </MenuItem>}
        {props?.loader ?  <Skeleton animation="wave" width={200} height={50}/> : 
        <MenuItem className="iconAlign subHeaderCard">
          <img src={calender} alt="location"  />

          <p className=" font14  marginInline">{details?.createdAt ? dateFormate(details?.createdAt, 'DD MMMM YYYY') : 'Not Available'}</p>
        </MenuItem>}

        {edit && (
          <CommonDialog
            open={edit}
            handleClose={handleClose}
            formData={props?.editData}
            button={'dialogButton'}
            onSubmittBtn={onDialog}
            type={'Edit '+ props?.type+" "}
            selectType={'edit'}
            details={details}
          />
        )}
        {successDialog && (
          <SuccessDialog
            open={successDialog}
            handleClose={handleClose}
            type={'Edit '+ props?.type}
          />
        )}
      </Grid>
    </Grid>
  );
}

export default SubHeaderDetails;
